import { render, staticRenderFns } from "./PaymentAuthorization.vue?vue&type=template&id=22b1d9da&scoped=true&"
import script from "./PaymentAuthorization.vue?vue&type=script&lang=js&"
export * from "./PaymentAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAuthorization.vue?vue&type=style&index=0&id=22b1d9da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b1d9da",
  null
  
)

export default component.exports